// @ts-strict-ignore
import { ChangeDetectionStrategy, Component, HostBinding, HostListener, Input, OnDestroy, OnInit } from '@angular/core';
import { LMFieldBaseComponent } from '@field/lm-field-base.component';
import { LMModel } from '@form/model';
import { LMFieldServiceAdapter } from '@field/lm-field-service-adapter';

enum LMCheckboxDisplayEnum {
  PLAIN = 0,
  SWITCH,
  DISPLAY_AS_TEXT,
  DISPLAY_AS_TAG
}

@Component({
  selector: 'lm-checkbox',
  standalone: false,
  templateUrl: './lm-checkbox.component.html',
  styleUrls: [ 'lm-checkbox.component.scss' ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LMCheckboxComponent extends LMFieldBaseComponent implements OnInit, OnDestroy {
  @Input() layoutObject: LMFormLayoutField;
  @Input() specFields: LMSpecFields;
  @Input() model: LMModel;
  @Input() lmColumnLayoutInfo: LMColumnLayoutInfo;
  @Input() lmParagraphLayoutInfo: LMParagraphLayoutInfo;

  @HostBinding('attr.data-automation-id') dataFieldAutomationId = '';

  @HostBinding('class.lm-parent-is-compound-field') get parentIsCompoundField() {
    if (this.lmColumnLayoutInfo?.parentIsCompoundField) {
      return true;
    }

    return false;
  }

  @HostBinding('class.lm-no-label-section-child') get noLabelSectionChild() {

    if (this?.lmParagraphLayoutInfo?.sectionInfo?.isNoLabelSection) {
      return true;
    }

    return false;
  }

  @HostBinding('class.lm-checkboxes-and-formtext') get onlyCheckboxesAndFormText() {
    if (this?.lmParagraphLayoutInfo?.sectionInfo?.isCheckboxesAndFormText) {
      return true;
    }

    return false;
  }

  // @HostBinding('class.lm-parent-is-compound-field') get parentIsCompoundField() {
  //   if (this.lmColumnLayoutInfo && this.lmColumnLayoutInfo.parentIsCompoundField) {
  //     this.lmFieldServiceAdapter.ngZone.runOutsideAngular(() => {
  //       setTimeout(() => this.lmColumnLayoutInfo.parentIsCompoundField)
  //     });
  //   } else {
  //     this.lmFieldServiceAdapter.ngZone.runOutsideAngular(() => setTimeout(() => false));
  //   }
  //
  //   return false;
  // }

  // LMWEB-17097 Field base handles on change. There is no need to have this one here since it ends up firing twice.
  // @HostListener('change')
  // onChange() {
  //   super.onChange();
  //   this.handleOnFieldChanged();
  // };

  public displayType: LMCheckboxDisplayEnum;
  public layoutDisplayType;
  public showDirtyCheckboxIndicator = false;

  constructor(protected lmFieldServiceAdapter: LMFieldServiceAdapter) {
    super(lmFieldServiceAdapter);
    this.layoutDisplayType = LMCheckboxDisplayEnum;
  }

  ngOnInit() {
    super.ngOnInit();
    this.initialize(this.layoutObject, this.specFields, this.model);

    if (this.layoutObject.displayAsTag) {
      this.displayType = LMCheckboxDisplayEnum.DISPLAY_AS_TAG;
    } else if (this.displayAsText) {
      this.displayType = LMCheckboxDisplayEnum.DISPLAY_AS_TEXT;
    } else if (this.layoutObject.displayAsSwitch) {
      this.subscribeToInlineError();
      this.displayType = LMCheckboxDisplayEnum.SWITCH;
      this._fieldClassArray.push('switch');

    } else {
      this.subscribeToInlineError();
      this.displayType = LMCheckboxDisplayEnum.PLAIN;
    }

    this.setFieldClasses();

    this.dataFieldAutomationId = `lm-${this.fieldAutomationId}-field`;
  }

  ngOnDestroy() {
    super.ngOnDestroy();
  }

  onAfterResetDirty(event: SohoTrackDirtyEvent) {
    // only reset dirty to pristine on change if already dirty
    if (this.isDirty) {
      if (this.isCompoundFieldMember && !this.isPreviewCompoundMember) {
        this.showDirtyCheckboxIndicator = false;
      }
    }
    super.onAfterResetDirty(event);
  }

  onDirty(event: SohoTrackDirtyEvent) {
    // only set dirty if not already dirty
    if (!this.isDirty) {
      if (this.isCompoundFieldMember && !this.isPreviewCompoundMember) {
        this.showDirtyCheckboxIndicator = true;
      }
    }
    super.onDirty(event);
  }

  onPristine(event: SohoTrackDirtyEvent) {
    // only set pristine if already dirty
    if (this.isDirty) {
      if (this.isCompoundFieldMember && !this.isPreviewCompoundMember) {
        this.showDirtyCheckboxIndicator = false;
      }
    }
    super.onPristine(event);
  }

  contextMenuClicked = ($event) => {
    this.onContextMenuEvent($event);
  };

  onModelChanged(value) {
    this.modelField.value = value;
  }
}
